import { postContentClass } from "@repo/fika-blog/src/classes"
import { extensions } from "@repo/fika-blog/src/extensions"
import { renderToHTMLString } from "@tiptap/static-renderer/pm/html-string"
import { createMemo } from "solid-js"

interface RichContentProps {
  content: string
}

export function RichContent(props: RichContentProps) {
  const html = createMemo(() => {
    try {
      return renderToHTMLString({
        extensions: extensions({ dropcursor: false, dropCap: false }),
        content: JSON.parse(props.content),
      })
    } catch {
      return ""
    }
  })

  return <div class={postContentClass} innerHTML={html()} />
}
